export default [
    {
        id: 9,
        path: '/myindex',
        name: '数据',
        component: resolve => require(['@/page/myindex/myindex.vue'], resolve),
        meta: {
            title: '数据'
        },
    }
]


// WEBPACK FOOTER //
// ./src/router/data.js